import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { FavoriteProductsFilterOptions } from './FavoriteProductsFilterOptions'
import { SortDirection, CursorMode } from './Enums'
/**
* Class ListingOptionsOfFavoriteProductsFilterOptions
*  Настройки запроса списка элементов с фильтрацией
*/
export class ListingOptionsOfFavoriteProductsFilterOptions extends ActiveModel {

/**
  * sortField
  * Поле для сортировки<br>
  */
  @ActiveField()
  sortField?: null | string


  /**
  * sortDirection
  * Направление сортировки<br>  *   * - `asc` По возрастанию  * - `desc` По убыванию  *   */
  @ActiveField()
  sortDirection?: SortDirection


  /**
  * cursorMode
  * Режим курсора. Если значение указано, то необходимо<br>указывать Web.Core.Pagination.SortOptions.CursorField и Web.Core.Pagination.SortOptions.CursorId  */
  @ActiveField()
  cursorMode?: null | CursorMode


/**
  * cursorField
  * Значение Web.Core.Pagination.SortOptions.SortField первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  cursorField?: null | string


/**
  * cursorId
  * Значение уникального ключа (чаще всего, но не обязательно, это id) первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  cursorId?: null | string


/**
  * query
  * Поисковый запрос<br>
  */
  @ActiveField()
  query?: string


  /**
  * limit
  * Кол-во элементов в результате. <br><br>Если значение меньше 1, то вернуть все элементы<br>  */
  @ActiveField()
  limit?: number


  /**
  * filter
  * Фильтр<br>  */
  @ActiveField({
    factory: [FavoriteProductsFilterOptions, () => undefined]
  })
  filter?: null | FavoriteProductsFilterOptions
}
